import { IPaginationRequest } from "interfaces/pagination";
import axios from "axios";

const WarrantyService = axios.create({
  baseURL: `${process.env.REACT_APP_TAYLORMADE}`,
});

const WarrantyServices = {
  getAllWarrantyReport: (
    token: string,
    pagination: IPaginationRequest,
    search: string,
    dateRange: {
      start: string;
      end: string;
    },
    enterAt: {
      start: string;
      end: string;
    },
  ) =>
    WarrantyService.post(
      "/warranties/find",
      {
        page: pagination.page,
        limit: pagination.per_page,
        search,
        start_purchase: dateRange.start,
        end_purchase: dateRange.end,
        start_expire: enterAt.start,
        end_expire: enterAt.end,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    ),

  getDetailWarrantyReport: (token: string, id: string) =>
    WarrantyService.get(`/warranties/id/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }),

  editWarrantyReport: (
    token: string,
    id: string | number,
    data: {
      warrantyexpire: string;
    },
  ) =>
    WarrantyService.patch(
      `/warranties/${id}`,
      {
        warrantyexpire: data.warrantyexpire,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    ),

  exportWarrantyReport: (
    token: string,
    search: string,
    dateRange: {
      start: string;
      end: string;
    },
    enterAt: {
      start: string;
      end: string;
    },
  ) =>
    WarrantyService.post(
      "/warranties/export",
      {
        format: "excel",
        search,
        start_purchase: dateRange.start,
        end_purchase: dateRange.end,
        start_expire: enterAt.start,
        end_expire: enterAt.end,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
      },
    ),

  // Dealers ------------------------------------------------------

  getAllDealers: (token: string, pagination: IPaginationRequest) =>
    WarrantyService.post(
      "/dealers/find",
      {
        page: pagination.page,
        limit: pagination.per_page,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    ),

  createDealer: (
    token: string,
    data: {
      name: string;
    },
  ) =>
    WarrantyService.post(`/dealers`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }),

  deleteDealer: (token: string, id: string | number) =>
    WarrantyService.delete(`/dealers/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }),
};

export default WarrantyServices;
